document.addEventListener("DOMContentLoaded", function () {
    const filterButtons = document.querySelectorAll(".sublink");
    const products = document.querySelectorAll(".product-card");

    if (!filterButtons.length || !products.length) return;

    filterButtons.forEach((button) => {
        button.addEventListener("click", function (event) {
            event.preventDefault(); // Previene el desplazamiento no deseado

            let filter = this.dataset.filter;

            // Cambia "all" a "todos" solo si es necesario
            if (filter === "all") filter = "todos";

            // Activar botón seleccionado
            filterButtons.forEach((btn) => btn.classList.remove("active"));
            this.classList.add("active");

            // Filtrar productos
            products.forEach((product) => {
                product.classList.toggle("hidden", !(filter === "todos" || product.classList.contains(filter)));
            });
        });
    });
});

